import { EventEmitter } from 'events';
import assign from 'object-assign';

import ApplicationDispatcher from '../../../dispatcher/ApplicationDispatcher.js';
import NotificationConstants from '../NotificationConstants.js';


/*
    Notification:
        {
            messages: Array
            eventID: null || String
            type:
                - alert
                - alert
                - warning
                - success
                - primary
                - info
        }
 */
var notifications = [];

var NotificationStore = assign({}, EventEmitter.prototype, {

    getNotifications: function () {
        return notifications;
    },

    emitChange: function () {
        this.emit('change');
    },

    addChangeListener: function (callback) {
        this.on('change', callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener('change', callback);
    }
});

NotificationStore.dispatchToken = ApplicationDispatcher.register(function (payload) {

    var action = payload.action, data = payload.action.data;

    switch (action.actionType) {
        case NotificationConstants.NOTIFY:
            notifications.push(data);
            NotificationStore.emitChange();
            break;

        case NotificationConstants.NOTIFICATION_NEXT:
            notifications.splice(0, 1);
            NotificationStore.emitChange();
            break;
    }
})

export default NotificationStore;
